import React, { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import MenuApp from "@menu/app";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StrictMode>
    <MenuApp />
  </StrictMode>
);
